import { render, staticRenderFns } from "./VerificacionTrazabilidad.vue?vue&type=template&id=f029ff34"
import script from "./VerificacionTrazabilidad.vue?vue&type=script&lang=js"
export * from "./VerificacionTrazabilidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports